/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { useDrag } from 'react-dnd';
import { Link } from 'react-router-dom';

import {
  MyTaskExtended,
  TASK_TYPE_TASK,
} from '@totem/components/ticketing/ticketing';
import IBDIcon from '@totem/styles/Icon';
import { DateStringToLocal } from '@totem/utilities/dateUtilities';

type Props = {
  color: string;
  task: MyTaskExtended;
};

const MyTaskKanbanTaskCard = ({ color, task }: Props) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: TASK_TYPE_TASK,
    item: task,
    canDrag: () => {
      return true;
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      style={{
        borderStyle: 'solid',
        borderWidth: 2,
        borderColor: color,
        marginBottom: 8,
        padding: '4px',
      }}
    >
      <div>
        <b>
          <Link to={`/dashboard/ticket/${task.ticket.id}`}>
            {task.ticket.number}
          </Link>
        </b>
      </div>
      <div>{task.ticket.summary}</div>
      <br />
      <div style={{ fontWeight: 700 }}>
        <IBDIcon name={task.type} style={{ marginRight: '16px' }} />
        {task.number}: {task.name}
      </div>
      {task.status === 'SCHEDULED' && (
        <div style={{ paddingLeft: '32px' }}>
          Scheduled Start: {DateStringToLocal(task.expectedStartDate)}
        </div>
      )}
      {task.status === 'IN PROGRESS' && (
        <div style={{ paddingLeft: '32px' }}>
          Started: {DateStringToLocal(task.actualStartDate)}
        </div>
      )}
      {task.status === 'COMPLETED' && (
        <div style={{ paddingLeft: '32px' }}>
          Completed: {DateStringToLocal(task.actualEndDate)}
        </div>
      )}
    </div>
  );
};

export default MyTaskKanbanTaskCard;
